import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import cogoToast from "cogo-toast";
import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import emarService from "../services/emar-medpass-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { Modal } from "react-responsive-modal";
import { selectUsers } from "../state/reducers/userSlice";
import Loader from "react-loader-spinner";



const EmarReasons = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [typeList, setTypeList] = useState([]);
  const [error, setError] = useState(false);
  const { user } = useSelector(selectUsers);
  const [isDefault, setIsDefault] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [selectedItem, setSelectedItem] = useState({});
  const onDeleteCloseModal = () => {
    setDeleteOpen(false);
    setSelectedId("");
  };

  const onAddCloseModal = () => {
    setAddOpen(false);
    setName("");
    setType("");
    setIsDefault(false);
    setError(false);
    setSelectedItem({});
  };
  const CustomCellType = ({ rowData }) => {
    let item = typeList.find(a => a.type === rowData.type)
    return (
      <span>{item?.reason_type}</span>
    )
  }

  const CustomCellDefault = ({ rowData }) => {
    return (
      <span>{rowData?.is_default === 'T' ? 'T' : ""}</span>
    )
  }
  const CustomCell = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3 cursor-pointer">
          <img src="/img/edit_icon.svg" onClick={() => {
            setName(rowData?.reason);
            setType(rowData?.type);
            setIsDefault(rowData?.is_default === 'T' ? true : false);
            setAddOpen(true);
            setSelectedItem(rowData);
          }} className="mt-1 w-4 h-4" alt="logo" />
        </span>
        <span className="inline-block mr-3 cursor-pointer">
          <img src="/img/delete.svg" onClick={() => {
            setSelectedId(rowData?.id);
            setDeleteOpen(true);
          }} className="mt-1 w-4 h-4" alt="logo" />
        </span>
      </div>
    );
  };

  const handleDelete = async (id) => {
    try {
      setLoading(true);
      await emarService.deletedReasons(id);
      let resp = await emarService.getReasons(user?.facility);
      dispatch(updateData(resp));
      setReasonList(resp);
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error deleting reason. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const tablePropsInit = {
    columns: [
      { key: "reason", title: "Name" },
      { key: "type", title: "Type" },
      { key: "is_default", title: "Default" },
      { key: "Actions", title: "Actions", style: { display: user.userRole === "FACILITY_ADMIN" ? '' : "none" } },
    ],
    singleAction: loadData(),
    sortingMode: SortingMode.Single,
    rowKeyField: "id",
    search: ({ searchText, rowData, column }) => {
      if (column.key === "passed") {
        return (
          (searchText === "false" && !rowData.passed) ||
          (searchText === "true" && rowData.passed)
        );
      }
    },
    paging: {
      enabled: true,
      pageIndex: 0,
      pageSize: 10,
      position: PagingPosition.Bottom,
    },
  };

  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const [reasonList, setReasonList] = useState([]);
  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = await emarService.getReasons(user?.facility);
      setLoading(false);
      setReasonList(resp);
      dispatch(updateData(resp));
    }
  };

  const handleCreation = async () => {
    try {
      if (name?.length === 0 || type?.length === 0) {
        setError(true);
        return false;
      }
      setLoading(true);
      let typeItem = typeList.find(a => a.type === type);
      let params = { "reason": name, "type": type, "fac_id": user?.facility, "is_default": isDefault ? 'T' : 'F', "reason_type": typeItem?.reason_type };
      if (selectedItem?.id) {
        params["id"] = selectedItem?.id;
      }
      await emarService.addReason(params);
      let resp = await emarService.getReasons(user?.facility);
      dispatch(updateData(resp));
      setLoading(false);
      setReasonList(resp);
      onAddCloseModal();

    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error processing request. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  const getReasonTypes = async (id) => {
    try {
      setLoading(true);
      const resp = await emarService.getReasonsTypes(id);
      setTypeList(resp);
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting reason types. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const getReasons = async (id) => {
    try {
      setLoading(true);
      const resp = await emarService.getReasons(id);
      setReasonList(resp);
      dispatch(updateData(resp));
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting reason types. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  useEffect(() => {
    getReasonTypes(user?.facility);
    getReasons(user?.facility);
  }, [user?.facility])

  useEffect(() => {
    if (typeList?.length) {
      dispatch(updateData(reasonList));
    }
  }, [typeList])

  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${loading ? "show" : "hidden"
          }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>

      <Modal open={deleteOpen} onClose={onDeleteCloseModal} center>
        <div className="pt-10 px-8 pb-4 ">
          <h3
            className="text-lg leading-6 font-medium text-gray-900 text-center"
            id="modal-headline"
          >
            Are you sure you want to delete?
          </h3>
          <div className="flex justify-center">
            <button
              onClick={() => {
                handleDelete(selectedId);
                setDeleteOpen(false);
              }}
              type="button"
              className="mr-4 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Yes
            </button>
            <button
              onClick={() => {
                setDeleteOpen(false);
              }}
              type="button"
              className="rounded font-medium h-10 text-white w-auto px-4 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Cancel
            </button>
          </div>
          {/*
           */}
        </div>
      </Modal>

      <Modal open={addOpen} onClose={onAddCloseModal} center>
        <div className="pt-10 px-8 pb-4 ">
          <h3
            className="text-2xl leading-6 font-bold text-labelclr pb-6 medicationHeading"
            id="modal-headline"
          >
            {selectedItem?.id ? "Edit" : "Create"}
          </h3>
          <ul className="text-left">
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Name
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>

              <input
                id="name"
                name="name"
                type="text"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className={` ${name?.length === 0 ? "border-red-400" : ""
                  } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
              />

              {error && name.length === 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify name
                </p>
              )}
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Type
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="type"
                aria-label="Select type"
                onChange={(e) => setType(e.target.value)}
                value={type}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="0">Select Type</option>
                {typeList
                  ? typeList.map((item, i) => {
                    return (
                      <option key={item.type} value={item.type}>
                        {item.reason_type}
                      </option>
                    );
                  })
                  : null}
              </select>
              {error && type.length === 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You must specify type
                </p>
              )}
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <span className=" py-2">
                <input
                  type="checkbox"
                  className="cursor-pointer  mb-4 "
                  name="is_default"
                  value={isDefault}
                  defaultChecked={isDefault}
                  onClick={(e) => {
                    setIsDefault(e.target.checked);
                  }}
                />
                {"  "} Make it default
              </span>
            </li>

            <li className="text-center">
              <button
                disabled={loading}
                onClick={() => handleCreation()}
                className={
                  loading
                    ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    : "text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                }
              >
                SUBMIT
              </button>
            </li>
          </ul>


        </div>
      </Modal>
      <div className="bg-white w-full   mx-auto mt-3 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-3 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl"></span>
          </div>
          <div className="w-full sm:w-1/2 text-right">
            <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-5/12 mb-2 h-10 mb--3 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className={`absolute w-4 h-4  right-5 ${user.userRole === "FACILITY_ADMIN" ? 'bottom-1' : 'bottom-5'}`}
              ></img>
            </span>

            {user.userRole === "FACILITY_ADMIN" && <span className="mr-3">
              <button
                onClick={() => setAddOpen(true)}
                className=" bg-header_bg rounded mb-2 py-2 px-7 cursor-pointer text-xs font-bold text-white h-10 inline-block shadow-md leading-6"
              >
                ADD REASON
              </button>
            </span>}

          </div>
        </div>
        <div className="p-2 text-xs usersList gridList overflow-x-auto">
          <Table
            {...tableProps}
            childComponents={{
              cellText: {
                content: (props) => {
                  // eslint-disable-next-line default-case
                  switch (props.column.key) {
                    case "type":
                      return <CustomCellType {...props} />
                    case "is_default":
                      return <CustomCellDefault {...props} />
                    case "Actions":
                      return <CustomCell {...props} />

                  }
                },
              },
            }}
            dispatch={dispatch}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(EmarReasons)
);
